import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetBillingStatusResponse } from './get-billing-status-response';
import { getBillingStatusResponseSchema } from './get-billing-status-response';

export async function getBillingStatusApi(): Promise<
  IValidatedResponse<IGetBillingStatusResponse>
> {
  return getRequest<IGetBillingStatusResponse>({
    path: '/billing',
    schema: getBillingStatusResponseSchema,
  });
}
